<template>
  <div class="searchterm">
    <div class="bg-overlay"></div>
    <div
      class="searchcontent"
      :class="{ 'is-dark': isDarkTheme }"
      v-click-outside="closePopup"
    >
      <div class="searchpopup">
        <div class="searchpopup-grid">
          <ul class="searchpopup-grid-list">
            <template
              v-for="(
                searchParameter, parameterIndex
              ) in searchParametersConstants"
              :class="{
                'has-dropdown': searchParameter.multiDropDownQueryOptions,
              }"
            >
              <li
                v-if="searchParameter.multiSearch"
                :key="parameterIndex"
                @click="inFocusIndex = parameterIndex"
              >
              <span class="select-tag" v-if="searchParameter.multiDropDownQueryOptions">
                  {{
                    getNameByQuery(
                      searchParameter,
                      searchParameter.currentQuerySelected
                    )
                  }}
                </span>
                <div class="searchpopup-grid-list-header">
                  {{
                    searchParameter.tname
                      ? $t(searchParameter.tname)
                      : searchParameter.name
                  }}
                </div>
                <div class="dropdown-section">
                  <div v-if="searchParameter.multiSearch === 'source'">
                    <Tag
                      v-if="isSourceText"
                      size="small"
                      align="top"
                      class="tag-grey"
                    >
                      {{ sourceSearchValueToDisplay }}
                      <span
                        class="pointer ml-5"
                        @click="removeTag(0, 'source')"
                      >
                        <svgicon name="icon-close" width="7" height="7" />
                      </span>
                    </Tag>
                    <Tag
                      v-if="isSourceNumber"
                      size="small"
                      align="top"
                      class="tag-grey"
                    >
                      + {{ sourceSearchMoreCount }}
                    </Tag>
                    <input
                      class="tag-input"
                      :placeholder="
                        !isSourceText
                          ? `Enter ${getPlaceholderText(searchParameter)}`
                          : ''
                      "
                      :style="!isSourceText ? `width:110px` : `width:50px`"
                      @input="sourceInputTag"
                      :value="sourceNewTag"
                      @keydown.enter="sourceAddNew($event, 'source')"
                    />
                    <span v-if="!isSourceText" class="icon-enter">
                      <svgicon name="icon-down-left" width="16" height="16" />
                      Enter
                    </span>
                    <div
                    class="search-dropdown"
                    v-if="inFocusIndex === parameterIndex && searchParameter.multiDropDownQueryOptions"
                  >
                    <div
                      v-for="(
                        option, dropdownIndex
                      ) in searchParameter.multiDropDownQueryOptions"
                      :key="dropdownIndex"
                    >
                      <div
                        class="list-item"
                        :class="{
                          'is-active':
                            searchParameter.currentQuerySelected ===
                            option.query,
                        }"
                        @click="onChangeOption(option.query, parameterIndex)"
                      >
                        <span>{{
                          option.tlabel ? $t(option.tlabel) : option.label
                        }}</span>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div
                    v-else-if="searchParameter.multiSearch === 'destination'"
                  >
                    <Tag
                      v-if="isDestinationText"
                      size="small"
                      align="top"
                      class="tag-grey"
                    >
                      {{ destinationSearchValueToDisplay }}
                      <span
                        class="pointer ml-5"
                        @click="removeTag(0, 'destination')"
                      >
                        <svgicon name="icon-close" width="7" height="7" />
                      </span>
                    </Tag>
                    <Tag
                      v-if="isDestinationNumber"
                      size="small"
                      align="top"
                      class="tag-grey"
                    >
                      + {{ destinationSearchMoreCount }}
                    </Tag>
                    <input
                      class="tag-input"
                      :placeholder="
                        !isDestinationText
                          ? `Enter ${getPlaceholderText(searchParameter)}`
                          : ''
                      "
                      :style="!isDestinationText ? `width:135px` : `width:50px`"
                      @input="destinationInputTag"
                      :value="destinationNewTag"
                      @keydown.enter="destinationAddNew($event, 'destination')"
                    />
                    <span v-if="!isDestinationText" class="icon-enter">
                      <svgicon name="icon-down-left" width="16" height="16" />
                      Enter
                    </span>
                    <div
                    class="search-dropdown"
                    v-if="inFocusIndex === parameterIndex && searchParameter.multiDropDownQueryOptions"
                  >
                    <div
                      v-for="(
                        option, dropdownIndex
                      ) in searchParameter.multiDropDownQueryOptions"
                      :key="dropdownIndex"
                    >
                      <div
                        class="list-item"
                        :class="{
                          'is-active':
                            searchParameter.currentQuerySelected ===
                            option.query,
                        }"
                        @click="onChangeOption(option.query, parameterIndex)"
                      >
                        <span>{{
                          option.tlabel ? $t(option.tlabel) : option.label
                        }}</span>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </li>
              <li
                v-else-if="searchParameter.dynamicDropDown"
                class="has-dropdown"
                :key="parameterIndex"
                @click="inFocusIndex = parameterIndex"
              >
                <div class="searchpopup-grid-list-header">
                  {{
                    searchParameter.tname
                      ? $t(searchParameter.tname)
                      : searchParameter.name
                  }}
                </div>
                <div v-if="searchParameter.dropDownCategory">
                  <Select
                    filterable
                    remote
                    clearable
                    :placeholder="searchParameter.placeholder"
                    :remote-method="data =>dynamicCategorySearchEmitter(data,searchParameter)"
                    :loading="optionsLoading"
                    :value="searchQuery[searchParameter.query]"
                    value-key="id"
                    @change="selectedDropdownItem($event, searchParameter.query)"
                    class="select-default"
                    popper-class="popper-dark"
                    >
                    <OptionGroup
                      v-for="group in dynamicSearchOptionsObj[searchParameter.query]"
                      :key="group.label"
                      :label="group.label">
                      <Option
                        v-for="item in group.options"
                        :key="item.id"
                        :label="item.label"
                        :value="item">
                        <span style="float: left">{{ item.label }} - {{ item.additional_label }}</span>
                      </Option>
                    </OptionGroup>
                  </Select>
                </div>
                <div v-else>
                  <Select
                    filterable
                    remote
                    clearable
                    :placeholder="searchParameter.placeholder"
                    :remote-method="data => dynamicSearchEmitter(data,searchParameter)"
                    :loading="optionsLoading"
                    :value="searchQuery[searchParameter.query]"
                    value-key="id"
                    @change="selectedDropdownItem($event, searchParameter.query)"
                    class="select-default"
                    popper-class="popper-dark"
                    >
                    <Option
                      v-for="item in dynamicSearchOptionsObj[searchParameter.query]"
                      :key="item.id"
                      :label="item.label"
                      :value="item">
                      <span style="float: left">{{ item.label }}</span>
                    </Option>
                  </Select>
                </div>
              </li>
              <li v-else-if="searchParameter.name === 'Ship-To' || searchParameter.name === 'Sold-To' || searchParameter.name === 'pickup'">
                <div class="searchpopup-grid-list-header">
                  {{
                    searchParameter.tname
                      ? $t(searchParameter.tname)
                      : searchParameter.name
                  }}
                </div>
                <div class="dropdown-section">
                <Select
                  v-model="queries[searchParameter.query]"
                  size="mini"
                  arrow="false"
                  :placeholder="searchParameter.placeholder"
                  :filterable="true"
                  class="select-default"
                  popper-class="popper-light">
                  <Option
                    v-for="(nameRefPair, id) in dropDownData[searchParameter.query + 'IdToNameRefMap']"
                    :key="id"
                    :label="nameRefPair"
                    :value="id"
                  ></Option>
                </Select>
                </div>
              </li>
              <li
                v-else-if="!searchParameter.multiDropDownQueryOptions"
                :key="parameterIndex"
                @click="inFocusIndex = parameterIndex"
              >
                <div class="searchpopup-grid-list-header">
                  {{
                    searchParameter.tname
                      ? $t(searchParameter.tname)
                      : searchParameter.name
                  }}
                  <Checkbox
                    :value="queries[searchParameter.query] ? true : false"
                    @change="unCheck(`${searchParameter.query}`)"
                    :disabled="!queries[searchParameter.query]"
                  ></Checkbox>
                </div>
                <div class="dropdown-section">
                  <input
                    :type="searchParameter.inputType || 'text'"
                    :placeholder="`Enter ${getPlaceholderText(
                      searchParameter
                    )}`"
                    :disabled="
                      disableSearchFields && disableField[searchParameter.query]
                    "
                    :value="queries[searchParameter.query]"
                    @input="validateInput($event, {...searchParameter, ...(searchParameter.inputType ?  {}: { inputType: 'text'})})"
                    @keydown.enter="keyEntered"
                  />
                </div>
              </li>
              <li
                v-else
                class="has-dropdown"
                :key="parameterIndex"
                @click="inFocusIndex = parameterIndex"
              >
                <span class="select-tag">
                  {{
                    getNameByQuery(
                      searchParameter,
                      searchParameter.currentQuerySelected
                    )
                  }}
                </span>
                <div class="searchpopup-grid-list-header">
                  {{
                    searchParameter.tname
                      ? $t(searchParameter.tname)
                      : searchParameter.name
                  }}
                  <Checkbox
                    :value="queries[searchParameter.query] ? true : false"
                    @change="unCheck(`${searchParameter.query}`)"
                    :disabled="!queries[searchParameter.query]"
                  ></Checkbox>
                </div>
                <div class="dropdown-section">
                  <input
                    :type="searchParameter.inputType || 'text'"
                    :placeholder="`Enter ${getPlaceholderText(
                      searchParameter
                    )}`"
                    :value="queries[searchParameter.query]"
                    @input="validateInput($event, {...searchParameter, ...(searchParameter.inputType ?  {}: { inputType: 'text'})})"
                  />
                  <div
                    class="search-dropdown"
                    v-if="inFocusIndex === parameterIndex"
                  >
                    <div
                      v-for="(
                        option, dropdownIndex
                      ) in searchParameter.multiDropDownQueryOptions"
                      :key="dropdownIndex"
                    >
                      <div
                        class="list-item"
                        :class="{
                          'is-active':
                            searchParameter.currentQuerySelected ===
                            option.query,
                        }"
                        @click="onChangeOption(option.query, parameterIndex)"
                      >
                        <span>{{
                          option.tlabel ? $t(option.tlabel) : option.label
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>
        <div class="btn-group">
          <button class="btn section_obtn" @click="reset">Clear</button>
          <button class="btn section_pbtn"
          :disabled="!shouldEnableSearch"
          @click="search">Search</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import debounce from 'debounce';

let value = [];

export default {
  props: {
    searchParameters: {
      type: Array,
      required: true,
      validator: (searchParameters) => {
        const properties = ['id', 'name', 'query'];
        const validPropertiesLength = properties.length;
        return searchParameters.every((parameter) => {
          if (typeof parameter !== 'object') {
            return false;
          }
          const validProperties = properties.filter((property) =>
            parameter.hasOwnProperty(property)
          );
          return Object.keys(validProperties).length === validPropertiesLength;
        });
      },
    },
    presearchedParams: {
      type: Object,
    },
    disableSearchFields: {
      type: Boolean,
      default: false,
    },
    isDarkTheme: {
      type: Boolean,
      default: false,
    },
    dropDownData: {
      type: Object,
    },
  },
  data() {
    return {
      // to track values provided in the pop up
      queries: {},
      searchQuery: {},
      searchParametersConstants: [],
      inFocusIndex: -1,
      disableField: {},
      sourceTags: [],
      destinationTags: [],
      destinationNewTag: '',
      sourceNewTag: '',
      value,
      sourcePlaceholder: true,
      destinationPlaceholder: true,
      isExtraSourceSearch: false,
      sourceSearchMoreCount: 0,
      sourceSearchValueToDisplay: '',
      isExtraDestinationSearch: false,
      destinationSearchMoreCount: 0,
      destinationSearchValueToDisplay: '',
      optionsLoading: false,
      dynamicSearchOptionsObj: {},
      searchQueryLabels: {},
    };
  },
  computed: {
    isSourceText() {
      return this.sourceTags.length;
    },
    isSourceNumber() {
      return this.sourceTags.length > 1;
    },
    isDestinationText() {
      return this.destinationTags.length;
    },
    isDestinationNumber() {
      return this.destinationTags.length > 1;
    },
    shouldEnableSearch() {
      return Object.keys(this.queries).some((value) => {
        const cleaned = this.queries[value] && this.queries[value].trim().replace(/[^a-zA-Z0-9]/g, '') || '';
        if(this.$route.path.startsWith('/mdm')){
          return cleaned.length >= 1;
        }
        return cleaned.length >= 3 || (['lr_number', 'order_number', 'indent_num', 'order_no'].includes(value) && this.queries[value]);
    });
}
  },
  methods: {
    getPlaceholderText(searchParameter) {
      if (searchParameter.tplaceholder) {
        return this.$t(searchParameter.tplaceholder);
      }
      return searchParameter.placeholder
        ? searchParameter.placeholder
        : (searchParameter.tname && this.$t(searchParameter.tname)) ||
            searchParameter.name;
    },

    destinationInputTag(ev) {
      ev.target.value = this.validateInput(ev, { inputType: 'text'});
      this.destinationNewTag = ev.target.value.trim();
    },
    sourceInputTag(ev) {
      ev.target.value = this.validateInput(ev, { inputType: 'text'});
      this.sourceNewTag = ev.target.value.trim();
    },
    validateInput(evt, searchParameter = {}) {
      const { inputType, query, allowBackSlash } = searchParameter;
      const regexStr= allowBackSlash ? /[^a-z0-9+@//\-_ .]/gi : /[^a-z0-9+@\-_ .]/gi;
      if(inputType) {
        evt.target.value = evt.target.value.replace(regexStr, '');
        if(query) {
          this.queries[query] = evt.target.value.trim();
        }
      }
      return evt.target.value.trim();
    },
    sourceAddNew(e, option) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      let addSuccess = false;
      if (this.sourceNewTag.includes(',')) {
        this.sourceNewTag.split(',').forEach((item) => {
          if (this.addTag(item.trim(), option)) {
            addSuccess = true;
          }
        });
      } else {
        if (this.addTag(this.sourceNewTag.trim(), option)) {
          addSuccess = true;
        }
      }
      if (addSuccess) {
        this.sourceNewTag = '';
      }
    },
    destinationAddNew(e, option) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      let addSuccess = false;
      if (this.destinationNewTag.includes(',')) {
        this.destinationNewTag.split(',').forEach((item) => {
          if (this.addTag(item.trim(), option)) {
            addSuccess = true;
          }
        });
      } else {
        if (this.addTag(this.destinationNewTag.trim(), option)) {
          addSuccess = true;
        }
      }
      if (addSuccess) {
        this.destinationNewTag = '';
      }
    },
    addTag(tag, option) {
      tag = tag.trim();
      if (option === 'source') {
        if (tag && !this.sourceTags.includes(tag)) {
          this.sourceTags.push(tag);
          if (this.sourceTags[0] && this.sourceTags[0].length <= 7) {
            this.sourceSearchValueToDisplay = this.sourceTags[0];
          } else if (this.sourceTags[0] && this.sourceTags[0].length > 7) {
            this.sourceSearchValueToDisplay =
              this.sourceTags[0].slice(0, 7) + '..';
          }
          this.queries['source'] = this.sourceTags;
          this.sourcePlaceholder = false;
          if (this.sourceTags.length <= 1) {
            this.enterStringToDisplaySource = false;
          }
          if (this.sourceTags.length > 1) {
            this.isExtraSourceSearch = true;
            this.sourceSearchMoreCount = this.sourceTags.length - 1;
          }
          return true;
        }
      } else {
        if (tag && !this.destinationTags.includes(tag)) {
          this.destinationTags.push(tag);
          if (this.destinationTags[0] && this.destinationTags[0].length <= 7) {
            this.destinationSearchValueToDisplay = this.destinationTags[0];
          } else {
            this.destinationSearchValueToDisplay =
              this.destinationTags[0].slice(0, 7) + '..';
          }
          this.queries['destination'] = this.destinationTags;
          this.destinationPlaceholder = false;
          if (this.destinationTags.length <= 1) {
            this.enterStringToDisplayDestination = false;
          }
          if (this.destinationTags.length > 1) {
            this.isExtraDestinationSearch = true;
            this.destinationSearchMoreCount = this.destinationTags.length - 1;
          }
          return true;
        }
      }
      return false;
    },
    removeTag(index, option) {
      if (option === 'source') {
        this.sourceTags.splice(index, 1);
        if (this.sourceTags[0] && this.sourceTags[0].length <= 7) {
          this.sourceSearchValueToDisplay = this.sourceTags[0];
        } else if (this.sourceTags[0] && this.sourceTags[0].length > 7) {
          this.sourceSearchValueToDisplay =
            this.sourceTags[0].slice(0, 7) + '..';
        }
        this.sourceSearchMoreCount--;
        if (this.sourceTags.length < 1) {
          this.enterStringToDisplaySource = true;
        }
        if (this.sourceTags.length <= 1) {
          this.isExtraSourceSearch = false;
        }
        if (this.sourceTags.length < 1) {
          this.sourcePlaceholder = true;
        }
      } else {
        this.destinationTags.splice(index, 1);
        if (this.destinationTags[0] && this.destinationTags[0].length <= 7) {
          this.destinationSearchValueToDisplay = this.destinationTags[0];
        } else if (
          this.destinationTags[0] &&
          this.destinationTags[0].length > 7
        ) {
          this.destinationSearchValueToDisplay =
            this.destinationTags[0].slice(0, 7) + '..';
        }
        this.destinationSearchMoreCount--;
        if (this.destinationTags.length < 1) {
          this.enterStringToDisplayDestination = true;
        }
        if (this.destinationTags.length <= 1) {
          this.isExtraDestinationSearch = false;
        }
        if (this.destinationTags.length < 1) {
          this.destinationPlaceholder = true;
        }
      }
    },
    closePopup() {
      this.$emit('closePopup');
    },
     keyEntered(){
      if(this.shouldEnableSearch){
        this.search();
      }
    },
    search() {
      let multiSearchEnabled = false;
      this.searchParametersConstants.forEach((searchParametersConstant) => {
        if (searchParametersConstant.multiSearch) {
          multiSearchEnabled = true;
        }
        if (searchParametersConstant.multiDropDownQueryOptions) {
          this.queries[searchParametersConstant.currentQuerySelected] =
            this.queries[searchParametersConstant.query];
          delete this.queries[searchParametersConstant.query];
        }
      });
      if (multiSearchEnabled && !this.sourceTags.length) {
        this.queries.source = null;
        if (this.queries.sourceNames) this.queries.sourceNames = null;
        if (this.queries.sourceRefIds) this.queries.sourceRefIds = null;
      }
      if (multiSearchEnabled && !this.destinationTags.length) {
        this.queries.destination = null;
        if (this.queries.destinationNames) this.queries.destinationNames = null;
        if (this.queries.destinationRefIds) this.queries.destinationRefIds = null;
      }
      if (this.$route.name === 'TrackDashboard') {
        this.$emit('search', { query: this.queries, queryLabels: this.searchQuery, displayLabels: this.searchQueryLabels });
      } else {
        this.$emit('search', this.queries);
      }
    },
    reset() {
      this.sourceTags = [];
      this.destinationTags = [];
      Object.keys(this.queries).forEach(
        (query) => (this.queries[query] = null)
      );
      const reset = true;
      this.$emit('search', this.queries, reset);
    },
    unCheck(param) {
      this.queries[param] = null;
    },
    onChangeOption(query, parameterIndex) {
      this.searchParametersConstants[parameterIndex] = Object.assign(
        this.searchParametersConstants[parameterIndex],
        { currentQuerySelected: query }
      );
      this.searchParametersConstants = [...this.searchParametersConstants];
    },
    getNameByQuery(searchParameter, query) {
      const nameDetails = searchParameter.multiDropDownQueryOptions.find(
        (val) => val.query === query
      );
      return nameDetails.ttypeLabel
        ? this.$t(nameDetails.ttypeLabel)
        : nameDetails.typeLabel;
    },
    dynamicSearchEmitter: debounce(async function (event, item) {
      if (event && event.length > 2) {
        this.optionsLoading = true;
        const result = await this.$store.dispatch(item.eventEmitter, {
          type: item.name,
          query: event,
        });
        let options = [];
        if(result) {
          options = result.map((resultItem, idx) => {
            return {
              id: idx,
              label: resultItem.name ? resultItem.name : resultItem,
              additional_label: resultItem.reference_id ? resultItem.reference_id : '',
            };
          });
        }
        this.dynamicSearchOptionsObj[item.query] = options;
        this.dynamicSearchOptionsObj = Object.assign({}, this.dynamicSearchOptionsObj);
        this.optionsLoading = false;
      }
    }, 300),
    dynamicCategorySearchEmitter: debounce(async function (searchQuery, item) {
      if (searchQuery && searchQuery.length > 2) {
        this.optionsLoading = true;
        const results = await this.getDynamicDropDownSearchData(searchQuery, item);
        for (let index = 0; index < item.dropDownCategory.length; index++) {
          const categoryObj = item.dropDownCategory[index];
          const options = results[index].map((resultItem, idx) => {
            return {
              id: idx,
              label: resultItem.name ? resultItem.name : resultItem,
              additional_label: resultItem.reference_id ? resultItem.reference_id : '',
            };
          });
          this.dynamicSearchOptionsObj[item.query][index] = {
            label: categoryObj.label,
            options,
            id: index,
          };
          this.dynamicSearchOptionsObj = Object.assign({}, this.dynamicSearchOptionsObj);
        }
        this.optionsLoading = false;
      }
    }, 300),
    selectedDropdownItem(event, field) {
      this.queries[field] = event.label;
      this.searchQuery[field] = event  ? (event.additional_label ? event.label + '-' + event.additional_label : event.label) : '';
      this.searchQueryLabels[`${field}_label`] =  this.searchQuery[field];
      this.queries = Object.assign({}, this.queries);
    },
    async getDynamicDropDownSearchData(searchQuery, item) {
      const result = await this.$store.dispatch(item.eventEmitter, {
            query: searchQuery,
          });
      if (result) {
        return [
          result.depots,
          result.consigneeDepots
        ];
      }
        return [];
    }
  },
  created() {
    this.searchParametersConstants = [...this.searchParameters];
    const hasSearchKey = Object.values(this.presearchedParams).some(
      (item) => item
    );
    this.searchParametersConstants.map((searchParameter, currentIndex) => {
      this.disableField[searchParameter.query] =
        hasSearchKey && !this.presearchedParams[searchParameter.query]
          ? true
          : false;
      if (searchParameter.multiDropDownQueryOptions) {
        let currentQuerySelected =
          searchParameter.multiDropDownQueryOptions[0].query;
        const containsPresearched = Object.keys(this.presearchedParams).find(
          (presearchedParam) =>
            searchParameter.multiDropDownQueryOptions.some(
              (item) => item.query === presearchedParam
            )
        );
        this.searchParametersConstants[currentIndex].currentQuerySelected =
          containsPresearched || currentQuerySelected;
        Vue.set(
          this.queries,
          searchParameter.query,
          this.presearchedParams[containsPresearched || currentQuerySelected]
        );
      }
      else if (searchParameter.dynamicDropDown) {
        if (searchParameter.dropDownCategory) {
          const categoryDropDown = searchParameter.dropDownCategory.reduce((acc, category) => {
            acc.push({
              label: category.label,
              options: [],
            });
            return acc;
          }, []);
          this.dynamicSearchOptionsObj[searchParameter.query] = categoryDropDown;
          Vue.set(
              this.queries,
              searchParameter.query,
              this.presearchedParams[searchParameter.query],
            );
          if (this.presearchedParams.displayLabels && this.presearchedParams.displayLabels[`${searchParameter.query}_label`]) {
              Vue.set(
              this.searchQuery,
              searchParameter.query,
              this.presearchedParams.displayLabels[`${searchParameter.query}_label`]
            );
            Vue.set(
              this.searchQueryLabels,
              [`${searchParameter.query}_label`],
              this.presearchedParams.displayLabels[`${searchParameter.query}_label`]
            );
          } else {
            Vue.set(
              this.searchQuery,
              searchParameter.query,
              this.presearchedParams[searchParameter.query]
            );
            Vue.set(
              this.searchQueryLabels,
              [`${searchParameter.query}_label`],
              this.presearchedParams[`${searchParameter.query}_label`]
            );
          }
        } else {
          this.dynamicSearchOptionsObj[searchParameter.query] = [];
          if (this.presearchedParams[searchParameter.query]) {
            Vue.set(
              this.queries,
              searchParameter.query,
              this.presearchedParams[searchParameter.query],
            );
          }
        }
      }
      else {
        Vue.set(
          this.queries,
          searchParameter.query,
          this.presearchedParams[searchParameter.query]
        );
      }
    });
    if (this.presearchedParams) {
      const preSearchedSource = this.presearchedParams.source || this.presearchedParams.sourceRefIds || 
        this.presearchedParams.sourceNames;
      const preSearchedDestination = this.presearchedParams.destination || this.presearchedParams.destinationRefIds || 
        this.presearchedParams.destinationNames;
      if (preSearchedSource && preSearchedSource.length) {
        this.sourceTags = preSearchedSource;
        if (
          preSearchedSource[0] &&
          preSearchedSource[0].length <= 7
        ) {
          this.sourceSearchValueToDisplay = this.sourceTags[0];
        } else if (
          preSearchedSource[0] &&
          preSearchedSource[0].length > 7
        ) {
          this.sourceSearchValueToDisplay = this.sourceTags[0].slice(0, 7) + '..';
        }
        this.sourceSearchMoreCount = preSearchedSource.length - 1;
      }
      if (preSearchedDestination && preSearchedDestination.length) {
        this.destinationTags = preSearchedDestination;
        if (
          preSearchedDestination[0] &&
          preSearchedDestination[0].length <= 7
        ) {
          this.destinationSearchValueToDisplay = this.destinationTags[0];
        } else {
          this.destinationSearchValueToDisplay =
            this.destinationTags[0].slice(0, 7) + '..';
        }
        this.destinationSearchMoreCount =
          preSearchedDestination.length - 1;
      }
    }
    // }
  },
  watch: {
    queries: {
      handler(newVal) {
        const hasSearchKey = Object.values(newVal).some((item) => item);
        Object.keys(newVal).forEach(
          (searchParam) =>
            (this.disableField[searchParam] =
              hasSearchKey && !newVal[searchParam] ? true : false)
        );
      },
      deep: true,
    },
  },
};
</script>
